import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import { format, isSameDay, parse } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import 'react-calendar/dist/Calendar.css';
import './CalendarioAulas.css';
import { teacherAPI } from '../../api/aulasApi';

const AulasCalendarCompact = () => {
    const [date, setDate] = useState(new Date());
    const [aulas, setAulas] = useState([]);
    const [selectedDay, setSelectedDay] = useState(null);

    useEffect(() => {
        const fetchAulas = async () => {
            try {
                const response = await teacherAPI.getMyClasses();
                const aulasConvertidas = response.data.map(aula => ({
                    ...aula,
                    date: parse(aula.dia, 'dd/MM', new Date()),
                }));
                setAulas(aulasConvertidas);
            } catch (error) {
                console.error('Erro ao buscar aulas:', error);
            }
        };

        fetchAulas();
    }, []);

    const hasAula = (day) =>
        aulas.some(aula => isSameDay(aula.date, day));

    const getAulasDoDia = (day) =>
        aulas.filter(aula => isSameDay(aula.date, day));

    const handleDayClick = (value) => {
        if (hasAula(value)) {
            setSelectedDay(value);
        }
    };

    return (
        <div className="compact-calendar-container">
            <p className="calendar-title">Seu calendário de aulas</p>
            <Calendar
                onChange={setDate}
                value={date}
                onClickDay={handleDayClick}
                locale="pt-BR"
                className="compact-calendar"
                tileClassName={({ date, view }) =>
                    view === 'month' &&
                    (hasAula(date) ? 'has-aula' : '') +
                    (isSameDay(date, new Date()) ? ' current-day' : '')
                }
            />

            {selectedDay && hasAula(selectedDay) && (
                <div className="aulas-popup">
                    <div className="popup-header">
                        <span className="popup-date">
                            {format(selectedDay, "EEEE, dd/MM/yyyy", { locale: ptBR })}
                        </span>
                        <button onClick={() => setSelectedDay(null)} className="close-popup">
                            ×
                        </button>
                    </div>
                    <div className="aulas-list">
                        {getAulasDoDia(selectedDay).map((aula, index) => (
                            <div key={index} className="horario-group">
                                <div className="horario-header">
                                    <span className="horario-time">{aula.time}</span>
                                </div>
                                <div key={index} className="aula-item">
                                    <div className="aula-details">
                                        <div className="aula-title">{aula.materia}</div>
                                        <div className="aula-info">
                                            <span className="aula-sala">Sala {aula.sala}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AulasCalendarCompact;
